import { render } from "./RealNameVerificationView.vue?vue&type=template&id=f140800a&scoped=true"
import script from "./RealNameVerificationView.vue?vue&type=script&lang=js"
export * from "./RealNameVerificationView.vue?vue&type=script&lang=js"

import "./RealNameVerificationView.vue?vue&type=style&index=0&id=f140800a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f140800a"]])

export default __exports__